import './CTAButton.css'
import { useSession } from '../../Utils/SessionProvider';

export function CTAButton({ cta }) {

    const session = useSession();

    const themeColor = cta && cta.themeColor ? cta.themeColor : session.theme.lightAccentColor;
    const label = cta?.label;
    const targetUrl = cta?.targetUrl;



    function handleCTAButton() {
        if (!targetUrl) return;
        window.open(targetUrl, "_blank");
    }

    if (!cta || !label || !targetUrl) {
        return null;
    } else {
        return <div className="CTA-button-wrapper">
            <button
            className="CTA-button-frame"
                style={{ backgroundColor: themeColor }}
                onClick={handleCTAButton}
            >
                <span className="cta-label">{ label }</span>
        </button>
        </div>
        
    }

    
}